module.exports = {"ignore":true}


//////////////////
// WEBPACK FOOTER
// ./src/templates/401/401.json
// module id = 412
// module chunks = 0